import { useEffect } from 'react'
import MainContent from './components/SingleStoryMainContent'
import SidebarContent from './components/SingleStorySidebarContent'
import {
  actions as paywallActions,
  getType,
  getBlur
} from 'src/features/paywall/PaywallSlice'
import commonStyles from 'src/styles/common.module.sass'
import { useDispatch, useSelector } from 'react-redux'
import useScrollBlock from 'src/hooks/useScrollBlock'
import Page from 'src/components/Page'
import { actions as viewActions } from 'src/features/views/ViewsSlice'
import { getStory } from 'src/features/singleStory/SingleStorySelector'
import Metadata from 'src/components/Metadata'
import cx from 'classnames'
import { siteName } from 'src/utils/oneCodeBase'

const viewsPayload = [
  {
    name: 'recent news'
  },
  {
    name: 'related analysis'
  },
  {
    name: 'related news'
  }
]

const SingleStoryPage = ({ match }) => {
  const story = useSelector(getStory())
  const dispatch = useDispatch()
  const paywallType = useSelector(getType)
  const blurArticle = useSelector(getBlur)
  const [blockScroll, allowScroll] = useScrollBlock()
  const id = match?.params?.id

  useEffect(() => {
    // Get Views for Single Story Page since they are used in main and sidebar content
    // Reports has related reports call, it does not use views
    if (siteName !== 'Reports') {
      dispatch(
        viewActions.requestSingleStoryViews({
          views: viewsPayload,
          articleId: id
        })
      )
    }

    return () => {
      dispatch(viewActions.cleanViews())
      if (paywallType !== 'ai_paywall' || paywallType !== 'free_feature') {
        dispatch(paywallActions.removePaywall())
      }
    }
  }, [id])

  useEffect(() => {
    if (blurArticle) {
      blockScroll()
    }

    return () => {
      allowScroll()
    }
  }, [blurArticle])

  return (
    <Page>
      <Metadata
        title={story?.title}
        description={story?.teaser}
        image={story?.image}
        publicationDate={story?.published}
        type="article"
        author={story?.author?.name}
      />
      <div
        className={cx(
          commonStyles.content,
          blurArticle ? commonStyles.blurPage : ''
        )}
      >
        <div className={commonStyles.main}>
          <MainContent id={id} />
        </div>
        <div className={commonStyles.sidebar}>
          <SidebarContent id={id} />
        </div>
      </div>
    </Page>
  )
}

export default SingleStoryPage
